import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { Box, Button, colors, IconButton, Tooltip, Typography } from "@mui/material"
import CategoryIcon from '@mui/icons-material/Category';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';

import authService from '../services/auth.service';

import { useStore } from '../store/StoredData';

const Header = () => {

    const history = useHistory();
    const { currentUser } = useStore();
    const [copied, setCopied] = useState(false)

    useEffect(() => { }, [currentUser])

    const handleCopyId = async () => {
        if (!currentUser?.userid) return
        try {
            await navigator.clipboard.writeText(String(currentUser.userid))
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch {
            // Fallback for HTTP environments (dev server)
            const el = document.createElement('textarea')
            el.value = String(currentUser.userid)
            document.body.appendChild(el)
            el.select()
            document.execCommand('copy')
            document.body.removeChild(el)
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        }
    }

    return (
        <Box width="100%" boxShadow={2} display="flex" flexDirection="row" justifyContent="space-around" alignContent="center" alignItems="center" bgcolor="darkblue" color={colors.grey[50]}>
            <Box textAlign="left" fontSize={12} fontWeight={500} padding='2px'>
                <a
                    onClick={() => history.push("/home")}
                    // href='/home'
                    title={'Reload Page'}
                    style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}>
                    <p style={{ margin: 0, padding: 0, letterSpacing: 10 }}>NEWS</p>
                    <p style={{ fontSize: 13, margin: 0, padding: 0, letterSpacing: 1, color: colors.amber[800] }}>CURATOR</p>
                    <p style={{ margin: 0, padding: 0, letterSpacing: 11 }}>TOOL</p>
                </a>
            </Box>
            <Box width="30%">&nbsp;</Box>
            {/* <Box width="35%"><Tabs /></Box> */}
            <Box width="50%" display="flex">
                {currentUser
                    ? <>
                        <Box width="100%" display="flex" justifyContent="flex-end" alignContent="center" alignItems="center">
                            {(currentUser.userid !== 2023032 && currentUser.userid !== 2023033) && <>
                                {/* Sector Screen: opens the sector-wise autodrafts screen */}
                                {/* Earlier implementation */}
                                {/* <Button variant='text' sx={{ color: colors.common.white, backgroundColor: colors.indigo[700], marginRight: '10px' }} onClick={() => history.push("/sector-screen")}>Sector Wise Drafts</Button> */}
                                {/* <Button variant='text' sx={{ color: colors.common.white, marginRight: '10px' }} onClick={() => history.push("/sector-screen")}>Sector Wise Drafts</Button> */}
                                <Button variant='text' sx={{ color: colors.common.white, marginRight: '10px' }} startIcon={<ViewColumnIcon />} onClick={() => history.push("/sector-screen")}>Sector Wise Drafts</Button>
                                <Button variant='text' sx={{ color: colors.common.white, marginRight: '10px' }} startIcon={<AddBoxIcon />} onClick={() => history.push("/articles/add")}>Add News</Button>
                                <Button variant='text' sx={{ color: colors.common.white }} startIcon={<CategoryIcon />} onClick={() => history.push("/manageCategories")}>A/C/D Cats &amp; Sub-Cats</Button>
                            </>}
                            <Box width="15%">&nbsp;</Box>
                            <Typography>Hi&nbsp;</Typography>
                            <Typography>{currentUser.first_name}</Typography>
                            <Tooltip title={copied ? 'Copied!' : 'Click to copy your NC User ID'} arrow>
                                <Box
                                    display='flex'
                                    alignItems='center'
                                    gap={0.5}
                                    onClick={handleCopyId}
                                    sx={{ cursor: 'pointer', mx: 1, px: 1, borderRadius: 1, '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                                >
                                    <Typography sx={{ color: colors.amber[400], fontWeight: 600 }}>
                                        NC ID: {currentUser.userid}
                                    </Typography>
                                    {copied
                                        ? <CheckIcon sx={{ fontSize: 14, color: colors.green[400] }} />
                                        : <ContentCopyIcon sx={{ fontSize: 14, color: colors.amber[400] }} />}
                                </Box>
                            </Tooltip>
                            <Typography>&nbsp;|</Typography>
                            <IconButton href='/login' title='Logout' onClick={() => authService.logout()}>
                                <PowerSettingsNewIcon color="error" />
                            </IconButton>
                        </Box>
                    </>
                    : <a href='/login' style={{ textDecoration: 'none', marginRight: 15, color: 'whitesmoke', alignContent: 'center', alignItems: 'center', alignSelf: 'center' }}>Login</a>
                }
            </Box>
        </Box >
    )
}

export default Header